import { Component, Input } from '@angular/core';
import { UserAchievement } from 'src/app/models/user-achievement.model';

@Component({
  selector: 'app-achievements-badge',
  templateUrl: './achievements-badge.component.html',
  styleUrls: ['./achievements-badge.component.scss']
})
export class AchievementsBadgeComponent {
  @Input() achievement!: UserAchievement;
  constructor() {}

  ngOnInit(): void {}
}
